import React from 'react'
import '../../styles/Diagnostic/DiagnosticDPE.css'
import { Fade } from 'react-awesome-reveal'
import diagnosticDPESection1 from '../../assets/diagnostic/diagnostic-dpe-section1.jpg'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticDPESection2 from '../../assets/diagnostic/diagnostic-dpe-section2.jpg'
import AccordionText from '../Utils/AccordionText'
import diagnosticDPESection3 from '../../assets/diagnostic/diagnostic-dpe-section3.jpg'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticDPE() {

    const section2AccordionData = [
        {
            title: "Conformité réglementaire",
            text: "Le DPE est obligatoire pour toute vente ou location immobilière. Il doit être présenté dès l’annonce de la transaction et remis à l’acquéreur ou au locataire."
        }, {
            title: "Économie d'énergie",
            text: "Il fournit des informations précieuses sur la consommation énergétique et l’impact environnemental du bien, permettant d’identifier les points d’amélioration pour réduire les coûts énergétiques."
        }, {
            title: "Valorisation du bien",
            text: "Un bon score de performance énergétique peut significativement augmenter l’attractivité de votre bien sur le marché immobilier."
        }
    ]

    const section3AccordionData = [
        {
            title: "Expertise approfondie",
            text: "Nos diagnostiqueurs certifiés disposant d’une connaissance approfondie des normes énergétiques et utilisent des méthodes d’évaluation avancées pour assurer l’exactitude de votre DPE."
        }, {
            title: "Conseil personnalisé",
            text: "Au-delà de l’évaluation, nous vous offrons des conseils sur mesure pour améliorer la performance énergétique de votre bien, ce qui peut se traduire par des économies substantielles et une meilleure empreinte écologique."
        }, {
            title: "Rapports détaillés et clairs",
            text: "Nous vous fournissons un rapport de DPE compréhensible et détaillé, mettant en lumière les caractéristiques énergétiques de votre bien ainsi que des recommandations pour améliorer sa performance."
        }, {
            title: "Service rapide et fiable",
            text: "Nous nous engageons à réaliser votre diagnostic dans les plus brefs délais, vous permettant ainsi de poursuivre rapidement vos projets de vente ou de localisation."
        },
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic DPE - E5M Diagnostics" />
                <meta name="description" content="Diagnostic DPE sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic DPE - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic DPE sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-DPE" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-DPE" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticDPE'>
                    <div id='header'>
                        <div id='diagnosticDPEHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Diagnostic DPE</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticDPESection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticDPESection1Left'>
                                    <h1 className='sectionTitle'>Votre Expert en Diagnostic de Performance Énergétique (DPE)</h1>
                                    <div className='sectionText'>
                                        Lors de la mise en vente ou en localisation de votre bien immobilier, le Diagnostic de Performance Énergétique (DPE) est une étape cruciale qui informe les futurs acquéreurs ou locataires sur l’efficacité énergétique de votre
                                        propriété. E5M Diagnostic s’engage à vous fournir un service de DPE fiable et conforme, vous aidant ainsi à valoriser votre bien tout en contribuant à la préservation de l’environnement.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticDPESection1Right'>
                                    <img src={diagnosticDPESection1} id='diagnosticDPESection1Image' alt='diagnostic-dpe-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticDPESection2'>
                        <Col sm={6}>
                            <div id='diagnosticDPESection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticDPESection2} className='diagnosticDPESection2Image' alt='diagnostic-dpe-section2-1' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticDPESection2Right'>
                                    <h1 className='sectionTitle'>Pourquoi le DPE est-il essentiel ?</h1>
                                    <div id='diagnosticDPESection2Accordion' className='sectionAccordion'>
                                        <Accordion>
                                            {section2AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticDPESection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticDPESection3Left'>
                                    <h1 className='sectionTitle'>Pourquoi choisir E5M Diagnostic pour votre DPE ?</h1>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section3AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticDPESection3Right'>
                                    <img src={diagnosticDPESection3} id='diagnosticDPESection3Image' alt='diagnostic-dpe-section3' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticDPESection4'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>E5M Diagnostic pour un DPE fiable</h1>
                            <div className='sectionText'>
                                Le Diagnostic de Performance Énergétique est un pilier de la transaction immobilière moderne, reflétant non seulement votre engagement envers la qualité de votre bien, mais aussi votre responsabilité environnementale. En sélectionnant
                                E5M Diagnostic, vous bénéficiez de l’expertise d’un leader dans le domaine, assurant la précision, la fiabilité et la conformité de votre diagnostic. Contactez-nous dès aujourd’hui pour planifier votre DPE et franchir une étape décisive
                                vers la réussite de votre transaction immobilière.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticDPE'>
                    <div id='header'>
                        <div id='diagnosticDPEHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic DPE</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticDPESection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Votre Expert en Diagnostic de Performance Énergétique (DPE)</h1>
                            <div className='sectionTextMobile'>
                                Lors de la mise en vente ou en localisation de votre bien immobilier, le Diagnostic de Performance Énergétique (DPE) est une étape cruciale qui informe les futurs acquéreurs ou locataires sur l’efficacité énergétique de votre
                                propriété. E5M Diagnostic s’engage à vous fournir un service de DPE fiable et conforme, vous aidant ainsi à valoriser votre bien tout en contribuant à la préservation de l’environnement.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticDPESection1} id='diagnosticDPESection1ImageMobile' alt='diagnostic-dpe-section1' />
                        </Fade>
                    </div>
                    <div id='diagnosticDPESection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticDPESection2} className='diagnosticDPESection2ImageMobile' alt='diagnostic-dpe-section2-1' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Pourquoi le DPE est-il essentiel ?</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticDPESection3Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi choisir E5M Diagnostic pour votre DPE ?</h1>
                            <div className='sectionAccordionDark sectionAccordionMobile'>
                                <Accordion>
                                    {section3AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticDPESection3} id='diagnosticDPESection3ImageMobile' alt='diagnostic-dpe-section3' />
                        </Fade>
                    </div>
                    <div id='diagnosticDPESection4Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>E5M Diagnostic pour un DPE fiable</h1>
                            <div className='sectionTextMobile'>
                                Le Diagnostic de Performance Énergétique est un pilier de la transaction immobilière moderne, reflétant non seulement votre engagement envers la qualité de votre bien, mais aussi votre responsabilité environnementale. En sélectionnant
                                E5M Diagnostic, vous bénéficiez de l’expertise d’un leader dans le domaine, assurant la précision, la fiabilité et la conformité de votre diagnostic. Contactez-nous dès aujourd’hui pour planifier votre DPE et franchir une étape décisive
                                vers la réussite de votre transaction immobilière.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default DiagnosticDPE